import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mentions',
  templateUrl: './mentions.component.html',
  styleUrls: ['./mentions.component.scss'],
})
export class MentionsComponent  implements OnInit {

  constructor(private readonly router : Router) { }

  ngOnInit() {}

  backClick() {
    this.router.navigateByUrl("/coach/about");
  }

}
